import React from 'react';
import { Doppelhaushaelfte } from './housetype-svgs/doppelhaushaelfte';
import { Einfamilienhaus } from './housetype-svgs/einfamilienhaus';
import { EinfamilienhausDefault } from './housetype-svgs/einfamilienhaus-default';
import { Reihenhaus } from './housetype-svgs/reihenhaus';

const getHouseTypeImage = (housetype?: string) => {
  switch (housetype) {
    case 'EINFAMILIENHAUS':
      return <Einfamilienhaus />;
    case 'DOPPELHAUSHAELFTE':
      return <Doppelhaushaelfte />;
    case 'REIHENHAUS':
      return <Reihenhaus />;
    default:
      return <EinfamilienhausDefault />;
  }
};

export const HouseTypeImage: React.FC<{ housetype?: string; className?: string }> = ({
  housetype,
  className
}) => {
  const houseTypeImage = getHouseTypeImage(housetype);

  return (
    <svg
      viewBox="0 0 636 493"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="houseType"
    >
      {houseTypeImage}
    </svg>
  );
};
